import { render } from "./Launchpad.vue?vue&type=template&id=1e96d3ab&ts=true"
import script from "./Launchpad.vue?vue&type=script&lang=ts"
export * from "./Launchpad.vue?vue&type=script&lang=ts"

import "./Launchpad.vue?vue&type=style&index=0&id=1e96d3ab&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__